module.exports = __webpack_public_path__ + "img/logo-google.b7727941.svg";